import { context } from "../../../components/wr-context";
import { getRowTextValue } from "../../../utils/product";
import { tagReplacer2 } from "../../../utils/proposals/tag-replacer";
var SELECTOR = "customSow";
export var replaceCustomSowTags = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        separator: ", ",
        selector: SELECTOR
    };
    return function(ctx) {
        var tags = {};
        context.state.cart.forEach(function(product) {
            product.rows.forEach(function(row) {
                var ref;
                var tag = (ref = row.options) === null || ref === void 0 ? void 0 : ref.tag;
                if (!(tag === null || tag === void 0 ? void 0 : tag.includes(options.selector))) return;
                if (!tags[tag]) tags[tag] = [];
                if (product.values[row.id]) {
                    tags[tag].push(getRowTextValue(product.values[row.id], options));
                }
            });
        });
        Object.keys(tags).forEach(function(tag) {
            var value = tags[tag].filter(function(s) {
                return s.trim();
            }).join(options.separator) || "";
            ctx.html = tagReplacer2(ctx.html, tag, value);
        });
    };
};
